import GlobalEventBus from '@/globalEventBus'

export default {
    namespaced: true,
    state: {
        eventBatchTimeout: null,
        eventBatchList: [],
        currentScanKeys: ""
    },
    getters: {

    },
    mutations: {

    },
    actions: {
        keyDown({ state, dispatch }, event) {
            if (event.ctrlKey == true) {
                return;
            }

            // If alt key is held down, assume is part of a scan event (for debuggin purposes)
            if (event.altKey == true) {
                dispatch("onScanKeyDown", event);
                return;
            }

            state.eventBatchList.push({
                keyCode: event.keyCode,
                key: event.key,
                target: event.target
            });

            if (state.eventBatchTimeout != null) {
                clearTimeout(state.eventBatchTimeout);
            }

            state.eventBatchTimeout = setTimeout(() => {
                dispatch("processEventBatch");
            }, 50); // Timeout after 50ms
        },
        processEventBatch({ state, dispatch }) {
            let eventBatchList = [...state.eventBatchList];
            state.eventBatchList.splice(0, state.eventBatchList.length);
            state.eventBatchTimeout = null;

            if (eventBatchList.length > 1) {
                eventBatchList.forEach(e => dispatch("onScanKeyDown", e));
            } else if (eventBatchList.length == 1) {
                GlobalEventBus.$emit("onKeyDown", eventBatchList[0]);
            }
        },
        onScanKeyDown({ state, dispatch }, event) {

            if (event.keyCode === 13) {
                dispatch("processScan", state.currentScanKeys);

                state.currentScanKeys = "";
            } else if (event.key != null && event.key.length == 1) {
                state.currentScanKeys += event.key;
            }
        },
        /* eslint-disable no-unused-vars */
        processScan({ dispatch }, keys) {
            if (keys.length < 5){
                return;
            }
            
            /**
             * Old code: all specimen display IDs used to be only numeric,
             * and all were 5 digits long. They were changed to include
             * the species code, and now are variable length.
             */
            // let scan = {
            //     code: keys,
            //     specimenDisplayID: keys.slice(-5)
            // };

            let scan = {
                code: keys,
                specimenDisplayID: keys
            };
            
            GlobalEventBus.$emit('onScan', scan);
        },
        /* eslint-enable no-unused-vars */
    }
}